module.exports = __webpack_public_path__ + "img/schultz.0d72e44f.png";